import { ManifestDiscrepancyEventType } from "generated-graphql/graphql";

/** Human wording per event type. A Record forces this to stay exhaustive as members are added. */
const EVENT_TYPE_LABELS: Record<ManifestDiscrepancyEventType, string> = {
  [ManifestDiscrepancyEventType.Opened]: "Opened",
  [ManifestDiscrepancyEventType.Reopened]: "Reopened",
  [ManifestDiscrepancyEventType.ValuesChanged]: "Values changed",
  [ManifestDiscrepancyEventType.EscalationChanged]: "Escalation changed",
  [ManifestDiscrepancyEventType.Resolved]: "Resolved",
  [ManifestDiscrepancyEventType.AutoResolved]: "Auto-resolved",
  [ManifestDiscrepancyEventType.AutoIgnored]: "Auto-ignored",
  [ManifestDiscrepancyEventType.Pending]: "Marked pending",
  [ManifestDiscrepancyEventType.Ignored]: "Marked as non-discrepancy",
  [ManifestDiscrepancyEventType.RuleChanged]: "Rule changed",
};

type EventActor = {
  person?: { first?: string | null; last?: string | null } | null;
} | null;

/**
 * One event history line's text: the event type in words, and who did it when
 * that is known. The server resolves `actor` to null for automatic events from
 * process-manifests, whose `actorId` is the literal "system", and null when the id no
 * longer matches a user. An actor with no name is left off the line rather
 * than printed as a raw id.
 */
export function describeDiscrepancyEvent(event: {
  eventType: ManifestDiscrepancyEventType;
  actorId: string;
  actor?: EventActor;
}): string {
  const label = EVENT_TYPE_LABELS[event.eventType];
  if (event.actorId === "system") return `${label} automatically by Encamp`;

  const name = [event.actor?.person?.first, event.actor?.person?.last]
    .filter((part) => part != null && part !== "")
    .join(" ");
  return name === "" ? label : `${label} by ${name}`;
}
